// extracted by mini-css-extract-plugin
export default {"title":"ticketerror_title__BjEBJ","text":"ticketerror_text__K2pzO"};